import React from 'react';
import ApiKeyManager from './ApiKeyManager';

/**
 * API Keys Page - ApiKeyManager 컴포넌트 래퍼
 * 추가적인 페이지 레이아웃이나 헤더 등을 제공
 */
const ApiKeys = () => {
  return (
    <div className="max-w-[1400px] mx-auto">
      <ApiKeyManager />
    </div>
  );
};

export default ApiKeys;
